import * as Zod from 'zod';

export const scoringValidator = Zod.object({
    __typename: Zod.literal('Scoring'),
    score: Zod.number(),
    scoringSystem: Zod.object({
        __typename: Zod.literal('ScoringSystem'),
        id: Zod.string(),
        nameSingular: Zod.string(),
        namePlural: Zod.string(),
    }),
});
